module.exports = __webpack_public_path__ + "img/rj.85276e66.png";